module.exports = __webpack_public_path__ + "static/media/facebook-messenger.535ff705.svg";